module.exports = __webpack_public_path__ + "img/course-bigcover03.f76e92be.png";